import { State, TemplateStaff } from './types';

export default {
  getTemplateStaff(state: State): TemplateStaff[] {
    return state.templateStaff;
  },
  getTemplateStaffById:
    (state: State) =>
    (staffId: number): TemplateStaff | undefined => {
      return state.templateStaff.find(staff => staff.id === staffId);
    },
  getTemplateStaffRole:
    (state: State) =>
    (staffId: number): string => {
      return state.templateStaff.find(staff => staff.id === staffId)?.role.name || '';
    }
};
